import { Box, Badge as ChakraBadge, Image } from "@chakra-ui/react";
import { KYDInternalCampaign } from "@common/interfaces/KYDCampaign";

const CampaignBadge = ({
  variant,
  type,
}: {
  variant: string;
  type: KYDInternalCampaign["type"];
}) => {
  const isKYD = type === "KYD";

  if (!isKYD) return null;
  return (
    <ChakraBadge
      variant={variant}
      borderRadius="full"
      px="8px"
      fontSize="11px"
      textTransform="none"
      color={isKYD ? "#424917" : "#718096"}
      textColor={isKYD ? "#424917" : "#718096"}
      fontWeight={"500"}
      bgColor={isKYD ? "#D3F227" : "transparent"}
      boxShadow={"none"}
      maxWidth="100%"
      borderWidth={"1px"}
      width={"fit-content"}
      borderColor={isKYD ? "#C0DC26" : "#718096"}
      display={"flex"}
      alignItems={"center"}
      gap={"4px"}
      height={"17px"}
    >
      {isKYD && (
        <Box width={"13px"} height={"13px"}>
          <Image src={"/crown.png"} alt="KYD" boxSize="13px" opacity={0.75} />
        </Box>
      )}
      {type}
    </ChakraBadge>
  );
};

export default CampaignBadge;
